export { BUDGET_TIER_LABEL } from "features/ProjectType/core";

export const STATUS = {
  WAITING_ASSIGN: "WAITING_ASSIGN",
  WAITING_QUOTE: "WAITING_QUOTE",
  QUOTED: "QUOTED",
  WON: "WON",
  LOST: "LOST",
  CANCELLED: "CANCELLED",
};
export const FINAL_STATUSES = [STATUS.WON, STATUS.LOST, STATUS.CANCELLED];
export const STATUS_LABEL = {
  WAITING_ASSIGN: "Chờ phân công",
  WAITING_QUOTE: "Chờ báo giá",
  QUOTED: "Đã báo giá",
  WON: "Đã chốt",
  LOST: "Không chốt",
  CANCELLED: "Huỷ",
};
export const STATUS_COLOR = {
  WAITING_ASSIGN: "#D8001A",
  WAITING_QUOTE: "#0068C7",
  QUOTED: "#4A26A6",
  WON: "#616161",
  LOST: "#616161",
  CANCELLED: "#616161",
};
export const TAB_ORDER = ["ALL", ...Object.keys(STATUS)];
export const TAB_LABEL = { ALL: "Tất cả", ...STATUS_LABEL };

export const TIMELINE_LABEL = {
  URGENT_WEEK: "Gấp trong tuần",
  IN_MONTH: "Trong tháng",
  ONE_TO_THREE_MONTHS: "1–3 tháng",
  SCHEDULED: "Hẹn lịch cụ thể",
};
export const BUDGET_TYPE = { TIER: "TIER", CUSTOM: "CUSTOM" };
export const ANSWER_TYPE = {
  NUMBER: "NUMBER",
  SHORT_TEXT: "SHORT_TEXT",
  SINGLE_CHOICE: "SINGLE_CHOICE",
  MULTI_CHOICE: "MULTI_CHOICE",
  YES_NO: "YES_NO",
};
export const SOURCE_LABEL = { HOME: "Trang chủ", VIEW_ALL: "Xem tất cả", PRODUCT: "Sản phẩm" };
export const HISTORY_ACTION_LABEL = {
  CREATE: "Tạo phiếu",
  ASSIGN: "Phân công",
  REASSIGN: "Đổi người phụ trách",
  STATUS_CHANGE: "Đổi trạng thái",
  NOTE: "Thêm ghi chú",
  FILE_UPLOAD: "Tải file",
  FILE_DELETE: "Xóa file",
};

// Đề xuất, chưa duyệt.
export const REASON_OPTIONS = {
  LOST: [
    { value: "CUSTOMER_REJECTED", label: "Khách từ chối báo giá" },
    { value: "NO_RESPONSE", label: "Khách không phản hồi" },
    { value: "OTHER", label: "Khác" },
  ],
  CANCELLED: [
    { value: "DUPLICATE", label: "Phiếu trùng" },
    { value: "SPAM", label: "Phiếu rác/thử nghiệm" },
    { value: "WRONG_INFO", label: "Khách nhập sai thông tin" },
    { value: "OTHER", label: "Khác" },
  ],
};
export const REASON_LABEL = Object.fromEntries(
  Object.values(REASON_OPTIONS)
    .flat()
    .map((o) => [o.value, o.label])
);

// Nút theo allowedTransitions: nhãn + kiểu. Không suy quyền từ vai trò.
export const TRANSITION_ACTION = {
  QUOTED: { label: "Đã gửi báo giá", primary: true },
  WON: { label: "Chốt", primary: true },
  LOST: { label: "Không chốt" },
  WAITING_QUOTE: { label: "Báo giá lại" },
  CANCELLED: { label: "Hủy phiếu" },
};

export const ERROR_CODE = {
  UNAUTHORIZED: "UNAUTHORIZED",
  CONFIG: "CONSULT_REQUEST_NOT_CONFIGURED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  VALIDATION_ERROR: "VALIDATION_ERROR",
  STATE_CHANGED: "CONSULT_REQUEST_STATE_CHANGED",
  LOCKED: "CONSULT_REQUEST_LOCKED",
  INVALID_TRANSITION: "CONSULT_REQUEST_INVALID_TRANSITION",
  REASON_REQUIRED: "CONSULT_REQUEST_REASON_REQUIRED",
  FILE_TYPE_NOT_ALLOWED: "FILE_TYPE_NOT_ALLOWED",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
};
// Các lỗi cần tải lại phiếu (PW4) sau khi toast.
export const RELOAD_ERROR_CODES = [
  ERROR_CODE.STATE_CHANGED,
  ERROR_CODE.LOCKED,
  ERROR_CODE.INVALID_TRANSITION,
  ERROR_CODE.FORBIDDEN,
];
export const ERROR_MESSAGE = {
  UNAUTHORIZED: "Không xác thực được với máy chủ phiếu tư vấn. Vui lòng tải lại trang hoặc đăng nhập lại.",
  CONSULT_REQUEST_NOT_CONFIGURED: "Chưa cấu hình kết nối tới máy chủ phiếu tư vấn. Vui lòng liên hệ quản trị hệ thống.",
  FORBIDDEN: "Bạn không có quyền cập nhật phiếu này.",
  CONSULT_REQUEST_LOCKED: "Phiếu đã khóa, không thể cập nhật",
  CONSULT_REQUEST_STATE_CHANGED: "Phiếu đã thay đổi trạng thái, vui lòng tải lại",
  CONSULT_REQUEST_INVALID_TRANSITION: "Không thể chuyển sang trạng thái này, vui lòng tải lại",
};
export const PAGE_SIZE = 20;
